"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _sagas = _interopRequireDefault(require("../../doctor/redux/sagas"));
var _sagas2 = _interopRequireDefault(require("../../search/redux/sagas"));
var _sagas3 = _interopRequireDefault(require("../../clinic/redux/sagas"));
var _sagas4 = _interopRequireDefault(require("../../appointment/redux/sagas"));
var _sagas5 = _interopRequireDefault(require("../../quickBooking/redux/sagas"));
var _sagas6 = _interopRequireDefault(require("../../postconsultation/redux/sagas"));
var _sagas7 = _interopRequireDefault(require("../../home/redux/sagas"));
var _sagas8 = _interopRequireDefault(require("../../waitingroom/redux/sagas"));
var _sagas9 = _interopRequireDefault(require("../../records/redux/sagas"));
var _sagas10 = _interopRequireDefault(require("../../notifications/redux/sagas"));
var _sagas11 = _interopRequireDefault(require("../../healthPackages/redux/sagas"));
// Imports: Redux Sagas
// Redux Saga: Root Saga
var _default = exports.default = [(0, _sagas.default)(), (0, _sagas2.default)(), (0, _sagas3.default)(), (0, _sagas4.default)(), (0, _sagas6.default)(), (0, _sagas7.default)(), (0, _sagas8.default)(), (0, _sagas9.default)(), (0, _sagas5.default)(), (0, _sagas10.default)(), (0, _sagas11.default)()];